'use client';

import React, { FC } from 'react';
import PortableTable from '../portableTable/PortableTable';
import styles from './TableContent.module.scss';
import Link from 'next/link';

type TTableContent = {
  headings: any[];
  activeAnchor: string | null;
  handleAnchorClick: (anchorKey: string) => void;
};

const TableContent: FC<TTableContent> = ({ headings, activeAnchor, handleAnchorClick }) => {
  return (
    <aside className={`${styles.table}`}>
      <div className={styles.table__info}>
        <ul className={styles.links__list}>
          <li>
            <strong>Contents:</strong>
          </li>
          {headings.map((heading) => {
            const anchorKey = heading.children[0].text.toLowerCase().replace(/\ /g, '-');

            const linkStyle = styles[`heading__${heading.style}`];
            return (
              <li
                key={heading._key}
                className={`${linkStyle} ${styles.table__link} ${
                  activeAnchor === anchorKey ? styles['active__link'] : ''
                }`}>
                <Link href={`#${anchorKey}`} onClick={() => handleAnchorClick(anchorKey)}>
                  <PortableTable value={heading} />
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
};

export default TableContent;
